import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';

const Section = styled.section`
  margin: 100px 0;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 50px;
`;

const Title = styled.h2`
  color: var(--lightest-slate);
`;

const Subtitle = styled.p`
  color: var(--slate);
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
`;

const Card = styled.article`
  background: var(--light-navy);
  border: 1px solid var(--lightest-navy);
  border-radius: var(--border-radius);
  padding: 24px;
  display: flex;
  flex-direction: column;
`;

const Quote = styled.blockquote`
  color: var(--lightest-slate);
  font-style: italic;
  line-height: 1.6;
  margin: 0 0 16px;
`;

const Author = styled.cite`
  color: var(--green);
  font-style: normal;
  font-weight: 600;
`;

const Role = styled.span`
  color: var(--slate);
  display: block;
  margin-top: 4px;
  font-size: var(--fz-sm);
`;

const Stars = styled.div`
  margin-bottom: 10px;
  span {
    color: var(--green);
  }
`;

const TestimonialsHome = () => {
  const data = useStaticQuery(graphql`
    query TestimonialsHomeQuery {
      testimonials: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/content/testimonials/" } }
        sort: { fields: [frontmatter___order], order: ASC }
        limit: 6
      ) {
        edges {
          node {
            id
            frontmatter {
              name
              title
              company
              rating
            }
            html
          }
        }
      }
    }
  `);

  const items = (data.testimonials?.edges || []).map(({ node }) => node);
  if (!items.length) {return null;}

  const renderStars = rating => {
    const r = parseInt(rating) || 5;
    return Array.from({ length: 5 }).map((_, i) => <span key={i}>{i < r ? '★' : '☆'}</span>);
  };

  return (
    <Section id="testimonials">
      <Header>
        <Title className="numbered-heading">Testimonials</Title>
        <Subtitle>What clients say about working with me.</Subtitle>
      </Header>

      <Grid>
        {items.map(({ id, frontmatter, html }) => (
          <Card key={id}>
            {frontmatter.rating && <Stars>{renderStars(frontmatter.rating)}</Stars>}
            <Quote dangerouslySetInnerHTML={{ __html: html }} />
            <Author>
              — {frontmatter.name}
              <Role>
                {frontmatter.title} at {frontmatter.company}
              </Role>
            </Author>
          </Card>
        ))}
      </Grid>
    </Section>
  );
};

export default TestimonialsHome;
